/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraIssuesTimeRangeFilter {
    getFixupPrototypeFunction() { return InfraIssuesTimeRangeFilter.fixupPrototype; }

    static newInstance(model: Partial<InfraIssuesTimeRangeFilter>): InfraIssuesTimeRangeFilter {
        let obj = Object.assign(new InfraIssuesTimeRangeFilter(), model);
        InfraIssuesTimeRangeFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraIssuesTimeRangeFilter>): InfraIssuesTimeRangeFilter {
        if (!model) return null;
        return InfraIssuesTimeRangeFilter.newInstance(<InfraIssuesTimeRangeFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraIssuesTimeRangeFilter) {
        if (!obj) return;

        models.InfraIssuesTimeRangeFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraIssuesTimeRangeFilter): boolean {
        Object.setPrototypeOf(obj, InfraIssuesTimeRangeFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Start date of the time period
     */
    start_date: Date;

    /**
     * End date of the time period
     */
    end_date: Date;

    /**
     * Granularity for aggregating issues trend data
     */
    granularity: models.InfraIssuesTrendGranularity;

}
